export default __webpack_public_path__ + "static/media/new_logo.4fecc9d8.png";